import { Tag } from './tag.type';
import { Person } from './person.type';

export enum TrainingEventStatus {
  OPEN = 'open',
  GRADED = 'graded',
}

export enum TrainingEventType {
  TRAINING = 'training',
  MATCH = 'match',
  EVENT = 'event',
}

export enum AttendanceStatus {
  PRESENT = 'present',
  EXCUSED = 'excused',
  UNEXCUSED = 'unexcused',
}

export enum ParticipantGrade {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum ParticipantResponse {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  DECLINED = 'declined',
}

export interface TrainingParticipant {
  id: number;
  person: Person;
  attendanceStatus: AttendanceStatus;
  grade?: ParticipantGrade;
  gradeNote?: string;
  gradedBy?: Person;
  response: ParticipantResponse;
  responseNote?: string;
  respondedAt?: string;
  // Who gave the current answer (the participant or one of their parents).
  respondedByName?: string;
}

export interface TrainingEvent {
  id: number;
  tags: Tag[];
  assignedPerson: Person;
  coTrainers?: Person[];
  date: string;
  startTime: number;
  duration: number;
  notes?: string;
  status: TrainingEventStatus;
  eventType: TrainingEventType;
  isCancelled: boolean;
  cancelReason?: string;
  participants?: TrainingParticipant[];
}
